import { Plus, Star, ChevronRight } from "lucide-react";
import { getDomainConfig } from "./constants";

const PanoramaCard = ({ 
  domain, 
  allDomainTasks, 
  domainTasks,
  onAddTask,
  onComplete,
  onViewInBacheca
}) => {
  const isCustom = domain.type === 'custom';
  const activeTasks = allDomainTasks.filter(t => !t.is_completed);
  const completedTasks = allDomainTasks.filter(t => t.is_completed);
  const completionPercent = allDomainTasks.length > 0 
    ? Math.round((completedTasks.length / allDomainTasks.length) * 100) 
    : 0;
  
  const previewTasks = domainTasks.slice(0, 2);
  const remainingCount = domainTasks.length - 2;
  
  return (
    <div 
      className={`bg-gradient-to-br ${domain.gradient} rounded-2xl p-4 border border-opacity-50 hover:shadow-lg transition-all cursor-pointer group`}
      onClick={onViewInBacheca}
    >
      {/* Header */}
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <span className="text-2xl">{domain.emoji}</span>
          <div>
            <h3 className="font-semibold text-gray-800">{domain.label}</h3>
            <p className="text-xs text-gray-500">{activeTasks.length} attivi</p>
          </div>
        </div>
        <button 
          onClick={(e) => {
            e.stopPropagation();
            onAddTask(isCustom ? "altro" : domain.key, isCustom ? domain.name : "");
          }}
          className="w-8 h-8 rounded-full bg-white/80 shadow-sm text-gray-500 flex items-center justify-center hover:bg-white hover:shadow-md transition-all opacity-0 group-hover:opacity-100"
        >
          <Plus className="w-5 h-5" />
        </button>
      </div>
      
      {/* Progress bar */}
      <div className="mb-3">
        <div className="flex justify-between text-[10px] text-gray-500 mb-1">
          <span>{completedTasks.length} su {allDomainTasks.length} completati</span>
          {activeTasks.filter(t => t.is_urgent).length > 0 && (
            <span className="text-red-500">{activeTasks.filter(t => t.is_urgent).length} urgenti</span>
          )}
        </div>
        <div className="h-1.5 bg-white/60 rounded-full overflow-hidden">
          <div 
            className={`h-full ${domain.progressColor || 'bg-indigo-400'} rounded-full transition-all`}
            style={{ width: `${completionPercent}%` }}
          />
        </div>
      </div>
      
      {/* Preview Tasks */}
      <div className="space-y-2">
        {previewTasks.length > 0 ? previewTasks.map(task => (
          <div 
            key={task.task_id} 
            className="flex items-center gap-2 bg-white/80 rounded-lg p-2"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => onComplete(task.task_id)}
              className="w-4 h-4 rounded border border-gray-300 hover:border-green-500 hover:bg-green-50 flex-shrink-0"
            />
            <span className="text-sm text-gray-700 truncate flex-1">{task.title}</span>
            {task.is_priority && <Star className="w-3 h-3 text-amber-500 fill-amber-400 flex-shrink-0" />}
          </div>
        )) : (
          <div className="text-center py-4">
            <p className="text-sm text-gray-400">Nessun compito</p>
            <button 
              onClick={(e) => {
                e.stopPropagation();
                onAddTask(isCustom ? "altro" : domain.key, isCustom ? domain.name : "");
              }}
              className="text-xs text-indigo-600 hover:text-indigo-800 mt-1"
            >
              + Aggiungi compito
            </button>
          </div>
        )}
        
        {remainingCount > 0 && (
          <button className="text-xs text-gray-500 hover:text-indigo-600 flex items-center gap-1 ml-2">
            Mostra {remainingCount} altro <ChevronRight className="w-3 h-3" />
          </button>
        )}
      </div>
    </div>
  );
};

export default PanoramaCard;
